import {
  useState,
  useContext,
  useCallback,
} from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const useFacebookOnboarding = () => {
  const { api, userID } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const postRequest = useCallback(
    async (endpoint, body) => {
      const response = await api.post(endpoint, body);
      return response?.data;
    },
    [api]
  );

  // ================= REGISTER MOBILE =================
  const registerMobileNumber = useCallback(async () => {
    try {
      const data = await postRequest(
        "/Account/v1/facebookRegisterMobileNumber",
        {
          userid: userID,
        }
      );

      return data;
    } catch (err) {
      setError(err);
      return null;
    }
  }, [postRequest, userID]);

  // ================= WEBHOOK PUSH =================
  const pushWebhookData = useCallback(
    async (payload) => {
      setLoading(true);

      try {
        const data = await postRequest(
          "/Account/v1/facebookSignupOnboardingWebhook",
          payload
        );

        return data;
      } catch (err) {
        setError(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    [postRequest]
  );

  return {
    loading,
    error,
    registerMobileNumber,
    pushWebhookData,
  };
};

export default useFacebookOnboarding;